module.exports = __webpack_public_path__ + "static/media/icono_gluten_am.63d8122d.png";